import { Route, Routes } from "react-router-dom";
import StoreDepositMaintenancePage from "@/pages/financial/store-deposit-maintenance";

export default function StoreDepositMaintenanceRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StoreDepositMaintenancePage />} />
    </Routes>
  );
}
